import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import api from '../../lib/api';

export default function AdminEvents() {
    const [data, setData] = useState({ items: [], counts_30d: [], total: 0 });
    useEffect(() => {
        api.get('/admin/events?limit=100').then((r) => setData(r.data));
    }, []);

    return (
        <AdminLayout title="Analítica de Eventos">
            <div className="grid md:grid-cols-2 gap-4 mb-5">
                <div className="bg-white rounded-2xl border border-gray-200 p-5">
                    <h3 className="text-sm font-bold text-brand-navy mb-3">Eventos (últimos 30 días)</h3>
                    {data.counts_30d.length === 0 ? <p className="text-xs text-gray-400 italic">Sin eventos aún. Cuando los usuarios usen la app, aparecerán aquí.</p> : (
                        <div className="space-y-2">
                            {data.counts_30d.map((c) => (
                                <div key={c.event} className="flex items-center justify-between text-sm">
                                    <span className="font-mono text-gray-700">{c.event}</span>
                                    <span className="font-bold text-brand">{c.count}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className="bg-white rounded-2xl border border-gray-200 p-5">
                    <h3 className="text-sm font-bold text-brand-navy mb-3">Total acumulado</h3>
                    <p className="text-4xl font-bold text-brand-navy">{data.total}</p>
                    <p className="text-xs text-gray-500">eventos registrados desde el inicio</p>
                </div>
            </div>

            <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 text-[11px] uppercase text-gray-500 tracking-wider">
                        <tr>
                            <th className="px-4 py-3 text-left">Evento</th>
                            <th className="px-4 py-3 text-left">Usuario</th>
                            <th className="px-4 py-3 text-left">Plataforma</th>
                            <th className="px-4 py-3 text-left">Fecha</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.items.map((e) => (
                            <tr key={e.id} className="border-t border-gray-100">
                                <td className="px-4 py-2 font-mono text-brand">{e.event}</td>
                                <td className="px-4 py-2 text-gray-600">{e.user_email || '—'}</td>
                                <td className="px-4 py-2 text-gray-500">{e.platform || e.ua?.slice(0, 40) || '—'}</td>
                                <td className="px-4 py-2 text-gray-500">{new Date(e.created_at).toLocaleString('es-ES')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </AdminLayout>
    );
}
